import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { api } from '../api';

// ── Types ─────────────────────────────────────────────────────

export interface GlobalSearchResult {
  id: string;
  title: string;
  subtitle: string | null;
  entityType: 'supplier' | 'contact' | 'mandate' | 'requirement';
}

export interface GlobalSearchResponse {
  suppliers: GlobalSearchResult[];
  contacts: GlobalSearchResult[];
  mandates: GlobalSearchResult[];
  requirements: GlobalSearchResult[];
}

// ── Hook ──────────────────────────────────────────────────────

export function useGlobalSearch(q: string) {
  return useQuery({
    queryKey: ['global-search', q],
    queryFn: () => api.get<GlobalSearchResponse>('/api/search', { q }),
    enabled: q.trim().length >= 2,
    placeholderData: keepPreviousData,
    staleTime: 10_000,
  });
}
